module.exports = __webpack_public_path__ + "img/icon_16.1b247745.png";